import { useNavigate } from 'react-router-dom';
import CreditCurrencyLogo from '../../../../assets/target/images/VerifyDevice.svg';
import Button from '../../../../components/Button';
import PageHeader from '../../../../components/PageHeader';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';

import './DeviceVerificationInfo.scss';

const { routes } = AppConfig;

const DeviceVerificationInfo = () => {
	const navigate = useNavigate();
	const next = () => {
		navigate({ pathname: routes.verifyDeviceVerify });
	};

	return (
		<div className='DeviceVerificationInfo'>
			<PageHeader header='' subheader='' />
			<div className='DeviceVerificationInfo__content'>
				<img src={CreditCurrencyLogo} />
				<h1 className='DeviceVerificationInfo__content-title'>{t('Verification required')}</h1>
				<p className='DeviceVerificationInfo__content-subtitle'>
					{t('This wallet is already active on another device. To continue using it here, please verify your identity')}
				</p>
			</div>
			<Button className='DeviceVerificationInfo__button' onClick={() => next()}>
				{t('Verify identity')}
			</Button>
		</div>
	);
};

export default DeviceVerificationInfo;
